import React from 'react'
import { Link } from 'react-router-dom'

const AboutSection = ({data}) => {
  console.log('--->about',data);
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{
              visibility: "visible",
              animationDelay: "0.1s",
              animationName: "fadeInUp"
            }}
          >
            <div className="row g-3 img-twice position-relative h-100">
              <div className="col-6">
                <img
                  className="img-fluid bg-light p-3"
                  src={data[0]}
                  alt=""
                />
              </div>
              <div className="col-6 align-self-end">
                <img
                  className="img-fluid bg-light p-3"
                  src={data[1]}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.5s"
            style={{
              visibility: "visible",
              animationDelay: "0.5s",
              animationName: "fadeInUp"
            }}
          >
            <div className="h-100">
              <p className="text-primary text-uppercase mb-2">About Us</p>
              <h1 className="display-6 mb-4">
                We Are Creative And Professional Photographer
              </h1>
              <p>
                Our journey of becoming a premium photography studio began years ago, and since then, we’ve beautifully captured the most cherished moments in the lives of thousands of couples across India. From pre-wedding shoots, wedding ceremonies, reception events, to suit and portrait photography, we cover it all with creativity and passion.l̥
              </p>
              <p>
              We take pride in having an in-house team of over 5 talented photographers, videographers, and cinematographers, dedicated to making your memories timeless. Equipped with the latest imported cameras, lenses, and advanced lighting gear, we ensure every frame tells a story.
              </p>
              <p>
              Our end-to-end services include everything from planning, photography, and cinematography to professional photo and video editing — all managed by our skilled in-house team. With our signature professionalism and warmth, we make sure you and your guests feel comfortable, celebrated, and happy being in front of the camera.
              </p>
              <div className="row g-2 mb-4">
                <div className="col-sm-6">
                  <i className="fa fa-check text-primary me-3" />
                  Quality Products
                </div>
                <div className="col-sm-6">
                  <i className="fa fa-check text-primary me-3" />
                  Custom Products
                </div>
                <div className="col-sm-6">
                  <i className="fa fa-check text-primary me-3" />
                  Online Order
                </div>
                <div className="col-sm-6">
                  <i className="fa fa-check text-primary me-3" />
                  Home Delivery
                </div>
              </div>
              <Link className="btn btn-primary py-3 px-5" href="">
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default AboutSection
